'use strict';
import classNames from 'classnames';
import React from 'react';
import {cachedFmtDate, cachedFmtTime, responseFieldViewpropTypes} from '../utils';


export function DateFieldViewView(props) {
  const result = props.value;
  const {options} = props.field;
  const value = [];

  if (options.includeDate) {
    value.push(cachedFmtDate(result.value) || '--/--/--');
  }

  if (options.includeDate && options.includeTime) {
    value.push(' ');
  }

  if (options.includeTime) {
    value.push(cachedFmtTime(result.value) || '--:--');
  }

  return (
    <p className={classNames("DateFieldView", props.className)}>
      {value.join('')}
    </p>
  );
}

DateFieldViewView.propTypes = responseFieldViewpropTypes;



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/DateFieldView/DateFieldViewView.js